/* HASANARAH theme — minimal vanilla JS for interactivity */
(function(){
  'use strict';

  // ============== Mobile menu ==============
  document.addEventListener('click', function(e){
    var toggle = e.target.closest('[data-mobile-toggle]');
    if (toggle) {
      var menu = document.querySelector('[data-mobile-menu]');
      if (menu) {
        var open = menu.hasAttribute('hidden');
        if (open) menu.removeAttribute('hidden'); else menu.setAttribute('hidden','');
        var iconMenu = toggle.querySelector('[data-icon-menu]');
        var iconClose = toggle.querySelector('[data-icon-close]');
        if (iconMenu && iconClose) {
          if (open) { iconMenu.setAttribute('hidden',''); iconClose.removeAttribute('hidden'); }
          else { iconMenu.removeAttribute('hidden'); iconClose.setAttribute('hidden',''); }
        }
      }
    }
  });

  // ============== Cart drawer ==============
  var drawer = document.querySelector('[data-cart-drawer]');
  function openCart(){
    if (!drawer) return;
    drawer.removeAttribute('hidden');
    drawer.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart(){
    if (!drawer) return;
    drawer.setAttribute('hidden','');
    drawer.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function(e){
    var trigger = e.target.closest('[data-cart-trigger]');
    if (trigger) { e.preventDefault(); openCart(); return; }
    var close = e.target.closest('[data-cart-close]');
    if (close) { e.preventDefault(); closeCart(); }
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeCart(); });

  function money(cents, currency){
    return (cents/100).toFixed(2) + (currency ? ' ' + currency : '');
  }

  function refreshCart(){
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        renderCart(cart);
        updateCartCount(cart.item_count);
      });
  }
  function updateCartCount(count){
    var el = document.querySelector('[data-cart-count]');
    if (!el) return;
    el.textContent = count;
    if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden','');
  }
  function renderCart(cart){
    var body = document.querySelector('[data-cart-body]');
    var footer = document.querySelector('[data-cart-footer]');
    var totalEl = document.querySelector('[data-cart-total]');
    if (!body) return;
    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<p class="hasanarah-empty">Nothing here yet.</p>';
      if (footer) footer.setAttribute('hidden','');
      return;
    }
    var html = '<ul class="hasanarah-cart-list">';
    cart.items.forEach(function(item, i){
      var img = item.image ? '<img src="'+item.image+'" alt="" width="80" height="100">' : '';
      var variant = (item.variant_title && item.variant_title.indexOf('Default') === -1) ? '<p class="hasanarah-cart-item__variant">'+item.variant_title+'</p>' : '';
      html += '<li class="hasanarah-cart-item">'+
        '<div class="hasanarah-cart-item__media">'+img+'</div>'+
        '<div class="hasanarah-cart-item__info">'+
          '<a href="'+item.url+'" class="hasanarah-cart-item__title">'+item.product_title+'</a>'+
          variant+
          '<p class="hasanarah-cart-item__price">'+money(item.final_price, cart.currency)+'</p>'+
          '<div class="hasanarah-qty">'+
            '<button type="button" data-line-update="'+(i+1)+'" data-qty="'+(item.quantity-1)+'" aria-label="Decrease">&minus;</button>'+
            '<input type="number" value="'+item.quantity+'" data-line-input="'+(i+1)+'" min="0">'+
            '<button type="button" data-line-update="'+(i+1)+'" data-qty="'+(item.quantity+1)+'" aria-label="Increase">+</button>'+
          '</div>'+
          '<button type="button" class="hasanarah-cart-item__remove" data-line-update="'+(i+1)+'" data-qty="0">Remove</button>'+
        '</div>'+
      '</li>';
    });
    html += '</ul>';
    body.innerHTML = html;
    if (totalEl) totalEl.textContent = money(cart.total_price, cart.currency);
    if (footer) footer.removeAttribute('hidden');
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-line-update]');
    if (!btn) return;
    e.preventDefault();
    var line = parseInt(btn.getAttribute('data-line-update'),10);
    var qty = parseInt(btn.getAttribute('data-qty'),10);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function(r){ return r.json(); })
      .then(function(cart){ renderCart(cart); updateCartCount(cart.item_count); });
  });

  // ============== Product variant selection ==============
  document.querySelectorAll('[data-product-form]').forEach(function(form){
    var variantsScript = form.querySelector('[data-variants-json]');
    if (!variantsScript) return;
    var variants;
    try { variants = JSON.parse(variantsScript.textContent); } catch(e) { return; }
    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = form.querySelector('[data-price]') || form.parentElement.querySelector('[data-price]') || document.querySelector('[data-price]');
    var stockEl = form.querySelector('[data-stock-status]');
    var addBtn = form.querySelector('[data-add-button]');
    var qtyInput = form.querySelector('[data-qty-input]');
    var qtyWrap = form.querySelector('[data-qty-wrap]');

    function findVariant(){
      var byPos = {};
      form.querySelectorAll('[data-option-input]:checked').forEach(function(input){
        var pos = parseInt(input.getAttribute('data-option-position'),10);
        if (pos) byPos[pos] = input.value;
      });
      var keys = ['option1','option2','option3'];
      return variants.find(function(v){
        return Object.keys(byPos).every(function(p){
          return v[keys[parseInt(p,10)-1]] === byPos[p];
        });
      });
    }

    function update(){
      var v = findVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price, '');
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to Bag' : 'Sold Out';
      }
      if (qtyWrap) {
        if (v.available) qtyWrap.removeAttribute('hidden'); else qtyWrap.setAttribute('hidden','');
      }
      if (stockEl) {
        if (!v.available) stockEl.textContent = 'Sold out';
        else if (v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= 3) stockEl.textContent = 'Only ' + v.inventory_quantity + ' left in stock';
        else stockEl.textContent = 'In stock';
      }
      if (qtyInput) {
        qtyInput.value = 1;
        if (v.inventory_management && typeof v.inventory_quantity === 'number') {
          qtyInput.max = v.inventory_quantity;
        } else {
          qtyInput.removeAttribute('max');
        }
      }
      // Toggle selected pill class
      form.querySelectorAll('[data-option-input]').forEach(function(input){
        var label = input.closest('.hasanarah-variants__pill');
        if (!label) return;
        if (input.checked) label.classList.add('is-selected'); else label.classList.remove('is-selected');
      });
    }

    form.addEventListener('change', function(e){
      if (e.target.matches('[data-option-input]')) update();
    });
  });

  // ============== Quantity buttons (product page) ==============
  document.addEventListener('click', function(e){
    var dec = e.target.closest('[data-qty-decrement]');
    var inc = e.target.closest('[data-qty-increment]');
    if (!dec && !inc) return;
    var form = (dec || inc).closest('form');
    if (!form) return;
    var input = form.querySelector('[data-qty-input]');
    if (!input) return;
    var v = parseInt(input.value,10) || 1;
    if (dec) v = Math.max(1, v - 1);
    if (inc) {
      var max = input.max ? parseInt(input.max,10) : null;
      if (max !== null && v >= max) return;
      v = v + 1;
    }
    input.value = v;
  });

  // ============== Async add-to-cart ==============
  document.addEventListener('submit', function(e){
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add-button]');
    if (btn) btn.disabled = true;
    var fd = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function(r){
        if (!r.ok) return r.json().then(function(d){ throw new Error(d.description || 'Cart error'); });
        return r.json();
      })
      .then(function(){ openCart(); })
      .catch(function(err){ alert(err.message); })
      .finally(function(){ if (btn) btn.disabled = false; });
  });

  // ============== Product gallery ==============
  document.querySelectorAll('[data-gallery]').forEach(function(gallery){
    var track  = gallery.querySelector('[data-gallery-track]');
    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var dots   = gallery.querySelectorAll('[data-gallery-dot]');
    if (!track || !slides.length) return;

    var current = 0;
    var total = slides.length;

    function update() {
      track.style.transform = 'translateX(' + (-current * 100) + '%)';
      thumbs.forEach(function(t, i){ t.classList.toggle('is-active', i === current); });
      dots.forEach(function(d, i){ d.classList.toggle('is-active', i === current); });
      var activeThumb = thumbs[current];
      if (activeThumb && activeThumb.scrollIntoView) {
        activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    }
    function go(i) {
      if (total < 1) return;
      current = (i + total) % total;
      update();
    }

    gallery.querySelectorAll('[data-gallery-prev]').forEach(function(b){
      b.addEventListener('click', function(e){ e.preventDefault(); go(current - 1); });
    });
    gallery.querySelectorAll('[data-gallery-next]').forEach(function(b){
      b.addEventListener('click', function(e){ e.preventDefault(); go(current + 1); });
    });
    thumbs.forEach(function(t){
      t.addEventListener('click', function(e){
        e.preventDefault();
        go(parseInt(t.getAttribute('data-index'), 10) || 0);
      });
    });
    dots.forEach(function(d){
      d.addEventListener('click', function(e){
        e.preventDefault();
        go(parseInt(d.getAttribute('data-index'), 10) || 0);
      });
    });

    // ----- Touch / pointer swipe -----
    var startX = 0, startY = 0, deltaX = 0, isDragging = false, lockedAxis = null, pointerId = null;
    var threshold = 40;

    function onStart(x, y, id) {
      isDragging = true; lockedAxis = null;
      startX = x; startY = y; deltaX = 0;
      pointerId = id != null ? id : null;
      track.classList.add('is-dragging');
    }
    function onMove(x, y, ev) {
      if (!isDragging) return;
      var dx = x - startX;
      var dy = y - startY;
      if (lockedAxis === null) {
        if (Math.abs(dx) > 8 || Math.abs(dy) > 8) {
          lockedAxis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        }
      }
      if (lockedAxis === 'x') {
        if (ev && ev.cancelable) ev.preventDefault();
        deltaX = dx;
        var pct = (-current * 100) + (dx / gallery.offsetWidth * 100);
        track.style.transform = 'translateX(' + pct + '%)';
      }
    }
    function onEnd() {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');
      if (lockedAxis === 'x' && Math.abs(deltaX) > threshold) {
        go(current + (deltaX < 0 ? 1 : -1));
      } else {
        update();
      }
      lockedAxis = null; deltaX = 0; pointerId = null;
    }

    // Pointer Events (covers modern mobile + desktop drag)
    if (window.PointerEvent) {
      track.addEventListener('pointerdown', function(e){
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        onStart(e.clientX, e.clientY, e.pointerId);
      });
      track.addEventListener('pointermove', function(e){
        if (!isDragging || (pointerId != null && e.pointerId !== pointerId)) return;
        onMove(e.clientX, e.clientY, e);
      });
      track.addEventListener('pointerup', onEnd);
      track.addEventListener('pointercancel', onEnd);
      track.addEventListener('pointerleave', function(e){ if (isDragging) onEnd(); });
    } else {
      // Touch fallback
      track.addEventListener('touchstart', function(e){
        var t = e.touches[0]; onStart(t.clientX, t.clientY);
      }, { passive: true });
      track.addEventListener('touchmove', function(e){
        var t = e.touches[0]; onMove(t.clientX, t.clientY, e);
      }, { passive: false });
      track.addEventListener('touchend', onEnd);
      track.addEventListener('touchcancel', onEnd);
    }

    // Prevent native image drag ghost
    gallery.querySelectorAll('img').forEach(function(img){
      img.addEventListener('dragstart', function(e){ e.preventDefault(); });
    });

    // Keyboard
    gallery.setAttribute('tabindex', '0');
    gallery.addEventListener('keydown', function(e){
      if (e.key === 'ArrowLeft')  { e.preventDefault(); go(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
    });

    update();
  });
   
  // Initial cart count fetch
  fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){ updateCartCount(cart.item_count); }).catch(function(){});
})();
document.addEventListener('click', function (event) {
  const thumb = event.target.closest('.hasanarah-gallery__thumb');
  if (!thumb) return;

  const gallery = thumb.closest('[data-gallery]');
  if (!gallery) return;

  const index = thumb.dataset.index;

  gallery.querySelectorAll('[data-gallery-image]').forEach((image) => {
    image.hidden = image.dataset.index !== index;
  });

  gallery.querySelectorAll('.hasanarah-gallery__thumb').forEach((button) => {
    button.classList.toggle('is-active', button.dataset.index === index);
  });
});
document.addEventListener('click', function (event) {
  const nav = event.target.closest('.hasanarah-gallery__nav');
  if (!nav) return;

  const gallery = nav.closest('[data-gallery]');
  if (!gallery) return;

  const images = Array.from(gallery.querySelectorAll('[data-gallery-image]'));
  const thumbs = Array.from(gallery.querySelectorAll('.hasanarah-gallery__thumb'));
  if (!images.length) return;

  let currentIndex = images.findIndex((image) => !image.hidden);
  if (currentIndex < 0) currentIndex = 0;

  const direction = nav.classList.contains('hasanarah-gallery__nav--next') ? 1 : -1;
  const nextIndex = (currentIndex + direction + images.length) % images.length;

  images.forEach((image, index) => {
    image.hidden = index !== nextIndex;
  });

  thumbs.forEach((button, index) => {
    button.classList.toggle('is-active', index === nextIndex);
  });
});